import { Drawer } from 'antd'
import React, { Component } from 'react'
import PropTypes from 'prop-types';
import EpisodePage from './EpisodePage'
import { getUUID, isAdmin } from '../../lib/utils';

export default class EpisodeDrawer extends Component {
    render() {
        const { podcastEpisode, userDetails, rawTokenCount, podcastEpisodes, itunesData } = this.props;
        const appEpisodeNumber = podcastEpisode && podcastEpisode.appEpisodeNumber;
        console.dir(appEpisodeNumber);
        console.dir(itunesData);
        return (
            <Drawer
                title={<div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    paddingRight: '2em',
                    paddingTop: '2px'
                }}>&nbsp;</div>}
                placement='right'
                closable={true}
                onClose={this.props.onDrawerClose}
                open={true}
                width={isAdmin(userDetails) ? '1550px' : '100vw'}
                key={podcastEpisode.guid}
            >
                <EpisodePage podcastEpisodeServer={{}} isServer={false} appEpisodeNumber={appEpisodeNumber}
                    podcastEpisodes={podcastEpisodes}
                    itunesData={itunesData}
                    rawTokenCount={rawTokenCount}
                    uuid={getUUID(podcastEpisode?.guid)} type='drawer' onCloseChild={this.props.onDrawerClose} />
            </Drawer>
        )
    }
}


EpisodeDrawer.propTypes = {
    podcastEpisode: PropTypes.object,
    itunesData: PropTypes.object,
    podcastEpisodes: PropTypes.array,
    userDetails: PropTypes.object,
    rawTokenCount: PropTypes.object,
    // showMore: PropTypes.bool,
    onDrawerClose: PropTypes.func,
}